import React, { Fragment } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import routes from './routes';
import RouterOutlet from './components/RouterOutlet';
import Sidebar from './components/Sidebar';
import DialogProvider from './providers/DialogProvider';
import { MobileProvider } from './providers/MobileProvider';
import { AuthContext } from './providers/AuthProvider';
import './App.css';

const App = () => {
  const auth = React.useContext(AuthContext);
  const { isLoggedIn } = auth;

  return (
    <Fragment>
      <CssBaseline />
      <DialogProvider>
        <MobileProvider>
          {isLoggedIn && (
            <Sidebar routes={routes} />
          )}
          {routes.map(route => (
            <RouterOutlet 
              key={route.path} 
              main={routes} 
              isLoggedIn={isLoggedIn}
              {...route} 
            />
          ))}
        </MobileProvider>
      </DialogProvider>
    </Fragment>
  );
};

export default App;
